export default __webpack_public_path__ + "static/media/smiling.a46d70d7.svg";